import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/constants';

import { CheckInLogDetailsService } from '@/features/check-in-logs/services';

export const useCheckInLogDetailsQuery = (id: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.checkInLogDetails(id),
    queryFn: async () => {
      const response = await CheckInLogDetailsService.GetCheckInLogDetails(id);
      return response.data;
    },
    enabled: !!id,
  });
};
